<!-- Button -->
<button [matMenuTriggerFor]="userActions">
  <span class="relative" style="display:flex;line-height:20px">
    <img class="avatar mr-0 mr-sm-16" [src]="profile_photo ? profile_photo : '/assets/images/avatars/profile.jpg'" alt="{{client_name}}">
    <span  class="username hidden sm:block" style="font-size: 12px; margin-left: 10px;font-weight:500">{{client_name}}<br /><span class="u-name" style="font-weight:normal">{{user_name}}</span></span>
    <mat-icon class="s-16" style="margin-top: 10px; margin-left: 5px;">keyboard_arrow_down</mat-icon>

  </span>
</button>

<mat-menu [xPosition]="'before'"
          #userActions="matMenu">

  <button mat-menu-item>
    <span class="flex flex-col leading-none">
      <span>Signed in as</span>
      <span class="mt-1.5 text-md font-medium">{{user_email}}</span>
    </span>
  </button>
  <!--<mat-divider class="my-2"></mat-divider>-->

  <button mat-menu-item [routerLink]="'/select-company'" data-case-id="btn_selcomp">
    <mat-icon>fact_check</mat-icon>
    <span>{{'SelectCompany' | translate}}</span>
  </button>


  <button mat-menu-item [routerLink]="'/account/user-profile'" data-case-id="btn_account">
    <mat-icon>account_circle</mat-icon>
    <span>{{'Account' | translate}}</span>
  </button>

  <button mat-menu-item class="" (click)="LogOut()" data-case-id="btn_logout">
    <mat-icon>exit_to_app</mat-icon>
    <span>{{'LogOut' | translate}}</span>
  </button>


</mat-menu>

  <mat-menu #thememode="matMenu">
    <button mat-menu-item (click)="SetThemeMode('light')" data-case-id="btn_dark" *ngIf="theme_mode=='dark'">{{ 'LightMode' | translate}}</button>
    <button mat-menu-item (click)="SetThemeMode('dark')" data-case-id="btn_light" *ngIf="theme_mode=='light'">{{ 'DarkMode' | translate}}</button>
  </mat-menu>


